<template>
  <div style="position: relative;">
    <div class="service-contact-section" v-if="product_id != 'rats'">
      <img class="bg_pic" src="@/assets/img/resources/why_pro_5.png" alt="拜耳虫虫拜拜工程师"/>

      <div class="service-content" style="position: relative">
        <div class="service-content-title white t-shadow">专业上门除虫服务</div>
        <div class="service-action-wrapper">
          <div class="diamond-btn-wrapper flex-row">
            <a id="connectitem_a_detailLink_mobile1" class="diamond-btn left mobile1" href="javascript:;" @click="detailLink" style="z-index: 9;" data-fuget="283">
              <div class="diamond"></div>
              <div class="title">{{contains.common.personal_service}}</div>
            </a>
            <a id="connect_a_utils_right" class="diamond-btn right slash-btn" @click="utils.ga.cta('Non-Resident')" :href="$rootUrl+'/enterprise'"
                data-fuget="283">
              <div class="diamond" style="background-color: #00BCFF;"></div>
              <div class="title">{{contains.common.enterprise_service}}</div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <we-chat-code :left="50" :top="325" v-show="showCode" :product_id="product_id"></we-chat-code>

    <el-dialog
      title=""
      top="20vh"
      :visible.sync="weixinDialogImg"
      class="weixin-dialog-img">
      <div class="con" v-if="codeImg == ''">
        <img v-lazy="require('@/assets/images/newhome/404.png')" style="width: 50%; height: auto;" />
        <p style="color: #4D4CC1;">服务即将上线，敬请期待</p>
      </div>
      <div class="con" v-else>
        <img v-lazy="require('@/assets/images/newhome/' + codeImg + '.png')" />
        <p>请微信扫码查看相关详情</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import contains from '@/controller/contains'
  import datas from '@/controller/data'
  import utils from '@/controller/utils'
  import WeChatCode from '@/components/weChatCode'
  import { get_url_link_for_product } from '@/api/api';

  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';

  export default {
    name: "connect_us_item",
    components: {
      'WeChatCode': WeChatCode
    },
    props: ['product_id', 'equipment', 'jump_to_detail','isPhoneSize'],
    data () {
      return {
        contains: contains,
        datas: datas,
        utils: utils,
        showCode: false,
        weixinDialogImg: false,
        codeImg: 'wx01'
      }
    },
    methods: {
      linkwxShow(name) {
        this.codeImg = name
        this.weixinDialogImg = true
      },
      detailLink(){
          let self = this
          if(self.product_id == 'cockroach') {
            if(self.isPhoneSize){
              self.getUrlLink('cockroachLite')
            }else{
              self.linkwxShow('wx02')
            }
            return
          }
          if(self.product_id == 'white_ant_check') {
            if(self.isPhoneSize){
              self.getUrlLink('white_ant_stand')
            }else{
              self.linkwxShow('wx04')
            }
            return
          }
          if(self.product_id == 'ants') {
            if(self.isPhoneSize){
              self.getUrlLink('antsPlus')
            }else{
              self.linkwxShow('wx06')
            }
            return
          }
          if(self.product_id == 'flea') {
            if(self.isPhoneSize){
              self.getUrlLink('fleaPlus')
            }else{
              self.linkwxShow('wx05')
            }
            return
          }
          if(self.product_id == 'mosquito') {
            if(self.isPhoneSize){
              self.getUrlLink('mosquito')
            }else{
              self.linkwxShow('wx07')
            }
            return
          }

          if(self.isPhoneSize){
            self.getUrlLink('pest_management') //百虫无忧
          }else{
            self.linkwxShow('wx01')
          }
      },
      getUrlLink(id){
        let self = this
        let params = {
          productId: id,
        }
        get_url_link_for_product(params).then((res) => {
          if(res.data.err == 0){
            location.href = res.data.data
          }else{
            self.$message.error(res.data.msg);
          }
        });
      },
      naviteTo(show) {
        if (this.equipment == 'pc') {
          if (show == 0) this.showCode = !this.showCode;
          else this.showCode1 = !this.showCode1;
        } else {
          window.location.href = this.$rootUrl + '/mobile/service_detail/' + this.product_id
        }
      },
      showCodeClick() {
        if (this.jump_to_detail) {
          console.log(this.product_id)
          if (this.utils.product_id_boolean(this.product_id)) {
            this.$router.push({path: `/service/${this.datas.product_list[this.product_id].product_name}`})
          } else {
            this.$router.push({path: '/service/profession'})
          }
        } else {
          this.showCode = !this.showCode;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .service-contact-section .bg_pic {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/connect_item.vue